import loadable from '@loadable/component';

import LoadingPage from '../../../components/LoadingPage';

const LoadableTermsOfUsePage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableTermsOfUsePage;
